import { graphql } from 'gql'

export const WORKSPACE_AMAZON_FRAGMENT_FOR_GET = graphql(`
  fragment WorkspaceAmazonFragmentForGet on WorkspaceAmazon {
    enabled
    id
    pubId
  }
`)
